var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-item"},[_c('h3',{staticClass:"chart-item-title textMainColor"},[_vm._v(_vm._s(_vm.$t('Long\/Short Ratio')))]),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }